<app-data-table-container class="max-h-[calc(52px*5)] border border-gray-200">
  <table mat-table [dataSource]="data()">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Naam</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center gap-2">
          <app-avatar
            class="block size-8 rounded-full overflow-hidden relative"
            [src]="element.fileUrl"
          >
            <div
              class="text-xl bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center opacity-100 transition-opacity"
            >
              <mat-icon inline>image</mat-icon>
            </div>
          </app-avatar>

          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.label"
            matTooltipPosition="after"
            >{{ element.label }}</span
          >
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>Grootte</th>
      <td mat-cell *matCellDef="let element">
        @if (element.metadata.size; as size) {
          {{ size | filesize }}
        } @else {
          -
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="dimensions">
      <th mat-header-cell *matHeaderCellDef>Afmetingen</th>
      <td mat-cell *matCellDef="let element">
        @if (element.metadata; as metadata) {
          @if (metadata.width && metadata.height) {
            {{ metadata.width }} × {{ metadata.height }}
          } @else {
            -
          }
        } @else {
          -
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (!hideActions()) {
          <button mat-icon-button (click)="itemRemove.emit(element.linkId)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="whitespace-nowrap"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hover:!bg-gray-100 whitespace-nowrap"
    ></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      <td
        class="mat-mdc-cell mdc-data-table__cell !border-none"
        [colSpan]="displayedColumns.length"
      >
        Geen resultaten gevonden
      </td>
    </tr>
  </table>
</app-data-table-container>
